import axios from 'axios';

export const getAllHomeServices= async () => {
    const url = `/api/v1/user_profile/home_services`;
    const res = await axios.get(url);
    return res.data;
};